// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.building-info-page {
  padding: 24px 28px;
}

.tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
  border-bottom: 1px solid #e5e7eb;
}

.tab {
  padding: 8px 12px;
  border: none;
  background: transparent;
  color: #6b7280;
  cursor: pointer;
  border-bottom: 2px solid transparent;
}

.tab.active {
  color: #111827;
  font-weight: 600;
  border-bottom-color: #2563eb;
}

.sections-nav {
  display: flex;
  gap: 24px;
  margin-bottom: 12px;
  color: #6b7280;
  font-size: 14px;
}

.section-link {
  cursor: default;
}

.section-link.active {
  color: #334155;
  font-weight: 600;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.page-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #111827;
}

.actions {
  display: flex;
  gap: 8px;
}

.btn {
  padding: 8px 14px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  background: #fff;
  color: #111827;
  cursor: pointer;
}

.btn.primary {
  background: #2563eb;
  color: #fff;
  border-color: #2563eb;
}

.btn.secondary {
  background: #fff;
}

.banner {
  padding: 10px 12px;
  border-radius: 8px;
  margin-bottom: 12px;
  font-size: 14px;
}

.banner.error {
  background: #fee2e2;
  color: #b91c1c;
}

.banner.success {
  background: #dcfce7;
  color: #166534;
}

.info-card {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}

.info-grid {
  display: grid;
  grid-template-columns: 1fr 2fr;
}

.info-label-cell {
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
  padding: 12px 16px;
  color: #374151;
  font-size: 14px;
}

.info-value-cell {
  border-bottom: 1px solid #e5e7eb;
  padding: 12px 16px;
}

.cell-input {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
}

.cell-input:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37,99,235,0.15);
}

.facade-area-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 980px;
  font-size: 14px;
}

.facade-area-table th,
.facade-area-table td {
  border: 1px solid #9ca3af;
  padding: 8px;
  text-align: center;
  vertical-align: middle;
}

.facade-area-table th {
  background: #f9fafb;
  color: #111827;
  font-weight: 600;
}

.facade-area-table td:first-child,
.facade-area-table th:first-child {
  text-align: left;
}

.facade-area-table .cell-input {
  min-width: 96px;
}

.facade-area-caption {
  margin-top: 8px;
  font-size: 15px;
  color: #111827;
}

.rich-editor {
  border: 1px solid #d1d5db;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

.rich-toolbar {
  display: flex;
  gap: 6px;
  padding: 8px;
  border-bottom: 1px solid #e5e7eb;
  background: #f9fafb;
}

.rich-toolbar .btn {
  min-width: 36px;
  padding: 6px 10px;
  font-size: 13px;
}

.rich-editor-surface {
  min-height: 260px;
  padding: 14px 18px;
  line-height: 1.6;
  font-size: 14px;
  color: #111827;
}

.rich-editor-surface:focus {
  outline: none;
  box-shadow: inset 0 0 0 3px rgba(37,99,235,0.12);
}

.rich-editor-surface p {
  margin: 0 0 12px;
}

.rich-editor-surface ol,
.rich-editor-surface ul {
  margin: 0 0 12px 24px;
  padding-left: 18px;
}
`, "",{"version":3,"sources":["webpack://./src/components/BuildingInfo.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,kBAAkB;AACpB","sourcesContent":[".building-info-page {\n  padding: 24px 28px;\n}\n\n.tabs {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 16px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.tab {\n  padding: 8px 12px;\n  border: none;\n  background: transparent;\n  color: #6b7280;\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n}\n\n.tab.active {\n  color: #111827;\n  font-weight: 600;\n  border-bottom-color: #2563eb;\n}\n\n.sections-nav {\n  display: flex;\n  gap: 24px;\n  margin-bottom: 12px;\n  color: #6b7280;\n  font-size: 14px;\n}\n\n.section-link {\n  cursor: default;\n}\n\n.section-link.active {\n  color: #334155;\n  font-weight: 600;\n}\n\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.page-header h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.actions {\n  display: flex;\n  gap: 8px;\n}\n\n.btn {\n  padding: 8px 14px;\n  border-radius: 8px;\n  border: 1px solid #d1d5db;\n  background: #fff;\n  color: #111827;\n  cursor: pointer;\n}\n\n.btn.primary {\n  background: #2563eb;\n  color: #fff;\n  border-color: #2563eb;\n}\n\n.btn.secondary {\n  background: #fff;\n}\n\n.banner {\n  padding: 10px 12px;\n  border-radius: 8px;\n  margin-bottom: 12px;\n  font-size: 14px;\n}\n\n.banner.error {\n  background: #fee2e2;\n  color: #b91c1c;\n}\n\n.banner.success {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.info-card {\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  overflow: hidden;\n  background: #fff;\n}\n\n.info-grid {\n  display: grid;\n  grid-template-columns: 1fr 2fr;\n}\n\n.info-label-cell {\n  background: #f9fafb;\n  border-bottom: 1px solid #e5e7eb;\n  padding: 12px 16px;\n  color: #374151;\n  font-size: 14px;\n}\n\n.info-value-cell {\n  border-bottom: 1px solid #e5e7eb;\n  padding: 12px 16px;\n}\n\n.cell-input {\n  width: 100%;\n  padding: 8px 10px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 14px;\n}\n\n.cell-input:focus {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37,99,235,0.15);\n}\n\n.facade-area-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 980px;\n  font-size: 14px;\n}\n\n.facade-area-table th,\n.facade-area-table td {\n  border: 1px solid #9ca3af;\n  padding: 8px;\n  text-align: center;\n  vertical-align: middle;\n}\n\n.facade-area-table th {\n  background: #f9fafb;\n  color: #111827;\n  font-weight: 600;\n}\n\n.facade-area-table td:first-child,\n.facade-area-table th:first-child {\n  text-align: left;\n}\n\n.facade-area-table .cell-input {\n  min-width: 96px;\n}\n\n.facade-area-caption {\n  margin-top: 8px;\n  font-size: 15px;\n  color: #111827;\n}\n\n.rich-editor {\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  overflow: hidden;\n  background: #fff;\n}\n\n.rich-toolbar {\n  display: flex;\n  gap: 6px;\n  padding: 8px;\n  border-bottom: 1px solid #e5e7eb;\n  background: #f9fafb;\n}\n\n.rich-toolbar .btn {\n  min-width: 36px;\n  padding: 6px 10px;\n  font-size: 13px;\n}\n\n.rich-editor-surface {\n  min-height: 260px;\n  padding: 14px 18px;\n  line-height: 1.6;\n  font-size: 14px;\n  color: #111827;\n}\n\n.rich-editor-surface:focus {\n  outline: none;\n  box-shadow: inset 0 0 0 3px rgba(37,99,235,0.12);\n}\n\n.rich-editor-surface p {\n  margin: 0 0 12px;\n}\n\n.rich-editor-surface ol,\n.rich-editor-surface ul {\n  margin: 0 0 12px 24px;\n  padding-left: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
